import customAxios from "../../customAxios";
import { FIND_DRIVER_CLOSED_FACTOR } from "../../routes";

interface iSendVerifyCode {
  driverId: string;
  page?: number;
  limit?: number;
  startAt?: string;
  endAt?: string;
}

const findDriverClosedFactor = async ({
  page = 1,
  limit = 10,
  driverId,
  startAt,
  endAt,
}: iSendVerifyCode) => {
  try {
    const res = await customAxios.post(
      FIND_DRIVER_CLOSED_FACTOR + "/" + driverId,
      {
        page,
        limit,
        startAt,
        endAt,
      }
    );
    return res.data;
  } catch (e) {
    console.log(e);
    return false;
  }
};
export default findDriverClosedFactor;
